import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Delete } from "@mui/icons-material";
import { layoutStyle } from "../pages/layout-ui/style";
import { TruckLoader } from "../pages/admin/truckLoader";

export const ConfirmAnalysisResultDialog = ({
  open,
  close,
  handleSave,
  setOpen,
  loading,
  setLoading,
  setAnalysisCompanyDefaultNameChange,
  companyNameHeader,
  setAnalysisDealerDefaultNameChange,
  dealerNameHeader,
  handleClose,
}) => {
  const classes = layoutStyle();

  const handleClick = async () => {
    setLoading(true);
    await handleSave();
  };

  // const handleClose = () => {
  //   setAnalysisCompanyDefaultNameChange(companyNameHeader);
  //   setAnalysisDealerDefaultNameChange(dealerNameHeader);
  //   setOpen(false);
  // };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <div>Are you sure you want to proceed?</div>
          <div
            style={{
              fontSize: 16,
              paddingTop: 15,
              color: "red",
            }}
          >
            Note: Please save your data before proceeding.
          </div>
        </DialogTitle>
        <DialogActions>
          <Button
            variant="outlined"
            type="submit"
            className={classes.analysisDilogCancelButton}
            autoFocus
            onClick={handleClose}
          >
            Cancel
          </Button>
          {loading ? (
            <TruckLoader />
          ) : (
            <Button
              variant="outlined"
              type="submit"
              className={classes.analysisDilogSaveButton}
              onClick={handleClick}
            >
              Save
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
